export default [
    {
        path: '/case-share-detail',
        name: 'caseShareDetail',
        meta: {
            title: '案源详情',
            activity: true
        },
        component: () => import('@/views/case-share-detail/index.vue')
    },  {
        path: '/lawsuit-share',
        name: 'lawsuitShare',
        meta: {
            title: '打官司详情',
            activity: true
        },
        component: () => import('@/views/lawsuitShare/index.vue')
    },
]
